import React from 'react';
import clsx from 'clsx';
import { SRL_DETAILS_TABLE } from '../../../../../../constants';
import MLIcon from '../../../../../../../../components/MLIcon/MLIcon';
import s from './ColumnHeader.module.css';

const ConfidenceSubHeader = ({ confidenceSubHeaders }) => {
  if (!confidenceSubHeaders) return null;

  return (
    <div>
      {confidenceSubHeaders.average && confidenceSubHeaders.maxValue && (
        <div className={s.subHeadersContainer}>
          <span>{confidenceSubHeaders.average}</span>
          {`/${confidenceSubHeaders.maxValue} average`}
        </div>
      )}
      {confidenceSubHeaders.change && (
        <div className={s.subHeadersContainer}>
          <span>{confidenceSubHeaders.change}</span>
        </div>
      )}
    </div>
  );
};

const HoursSubHeader = ({ hoursSubHeaders }) => {
  if (!hoursSubHeaders) return null;

  return (
    <div>
      {hoursSubHeaders.median && (
        <div className={s.subHeadersContainer}>
          <span>{hoursSubHeaders.median}</span> h median
        </div>
      )}
      {hoursSubHeaders.change && (
        <div className={s.subHeadersContainer}>
          <span>{hoursSubHeaders.change}</span> h
        </div>
      )}
    </div>
  );
};

function ColumnHeader({
  column,
  headerSubText,
  confidenceSubHeaders,
  hoursSubHeaders,
  handleSortClick,
  selectedSortSettings,
}) {
  const { sortColumn, sortDirection } = selectedSortSettings;
  const { accessor, centerText, width, flexBasis, emptyHeader } = column;
  const sortAscending = sortDirection === SRL_DETAILS_TABLE.SORT_ASCENDING;
  const icon = sortAscending ? 'caret_up' : 'caret_down';

  return (
    <div
      role="columnheader"
      className={clsx(s.columnHeader, { [s.centerColumn]: centerText })}
      style={{
        width,
        flexBasis,
        ...(width && { flexShrink: 0 }),
      }}
    >
      {!emptyHeader && (
        <>
          <button
            className={clsx(s.sortButton, {
              [s.centerButton]: centerText,
            })}
            onClick={() => handleSortClick(accessor)}
          >
            <div className={s.sortButtonLabelContainer}>
              {column.renderLabel()}
              {sortColumn === accessor && (
                <span
                  className={s.iconContainer}
                  aria-sort={sortAscending ? "ascending" : "descending"}
                >
                  <MLIcon
                    className={s.sortIcon}
                    height={15}
                    width={15}
                    role="presentation"
                    type={icon}
                  />
                </span>
              )}
            </div>

            <ConfidenceSubHeader confidenceSubHeaders={confidenceSubHeaders} />
            <HoursSubHeader hoursSubHeaders={hoursSubHeaders} />
          </button>
          <div className={s.displayNumber}>{headerSubText}</div>
        </>
      )}
    </div>
  );
}

export default ColumnHeader;
